import '../App.css';
import React from 'react';
import { Footer } from '../Components/Footer';
import OrangeButton from '../Components/buttons/orange-button';
import ContactTestimonialCarousel from '../Components/contact/ContactTestimonialCarousel';
import HeroContainer from '../Components/ui/hero-container';
import HeaderAlt from '../Components/HeaderAlt';

export default function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div>
      <HeaderAlt />
      <HeroContainer className={'!pb-[130px] !pt-12 md:!pb-0 md:!pt-[72px]'}>
        <div className="w-full">
          <div className="container relative mx-auto px-4 py-8 lg:py-12">
            <div className="flex flex-col items-center gap-8 pb-24 lg:flex-row lg:pb-0">
              {/* Left Content */}
              <div className="space-y-8 text-center text-white md:text-left lg:w-1/2">
                <h1 className="hero-title fredokaOne ">We&apos;d love to help</h1>
                <p className="mx-auto w-[80%] text-center font-[Fredoka] text-[19px] font-medium leading-[32px] tracking-[-0.22px]  text-[#678285] md:ml-0 md:text-left md:text-[22px] lg:w-full">
                  Reach out to us by sending us a message and we&apos;ll get back to you within the
                  next 24 hours
                </p>
                <div className="flex justify-center md:justify-start">
                  <div className="space-y-6">
                    <div className="flex items-center gap-4">
                      <div className="rounded-full bg-teal-200 p-3">
                        <svg
                          className="h-6 w-6 text-teal-900"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          />
                        </svg>
                      </div>
                      <span className="font-[Fredoka] text-[22px] font-medium leading-[32px] tracking-[-0.22px] text-white">
                        inquiries@iamai.co
                      </span>
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="rounded-full bg-yellow-200 p-3">
                        <svg
                          className="h-6 w-6 text-yellow-900"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                          />
                        </svg>
                      </div>
                      <span className="font-[Fredoka] text-[22px] font-medium leading-[32px] tracking-[-0.22px] text-white">
                        +1 (713) 417-3163
                      </span>
                    </div>
                  </div>
                </div>

                <div className="hidden lg:block">
                  <img
                    src="/images/contact/contact-hero.png"
                    alt="Happy students"
                    className="w-full max-w-[400px] rounded-lg object-cover"
                  />
                </div>
              </div>

              {/* Right Form */}
              <div className="absolute top-[95%] mx-4 max-w-[500px] lg:right-0 lg:top-10">
                <div className="space-y-8 rounded-[24px] bg-[#E0F5F5] p-4 shadow-lg md:p-8">
                  <h2 className="text-center font-[Fredoka] text-[19px] font-medium leading-normal tracking-[-0.64px] text-[#012E33] md:text-[32px]">
                    Send us a message
                  </h2>
                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-2">
                      <label className="font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                        First Name*
                      </label>
                      <input
                        type="text"
                        placeholder="Enter your First Name"
                        className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-2 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                        Last Name*
                      </label>
                      <input
                        type="text"
                        placeholder="Enter your Last Name"
                        className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-2 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                        Email*
                      </label>
                      <input
                        type="email"
                        placeholder="Enter your Email"
                        className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-2 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                        Company/Organization Name*
                      </label>
                      <span className="font-[Fredoka] text-[14px] leading-[20px] text-[#678285]">
                        If you&apos;re not contacting us as a member of an organization, please
                        enter your occupation (such as &apos;tutor&apos;) or reason for contacting
                        us.
                      </span>
                      <input
                        type="text"
                        placeholder="Enter your Company/Organization Name"
                        className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-2 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                        How would you like to work with us?
                      </label>
                      <textarea
                        rows="4"
                        placeholder="Write a message"
                        className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-2 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                      ></textarea>
                    </div>

                    <div className=" !mt-8 flex w-full justify-center ">
                      <OrangeButton className="!w-[189px]" label={'Submit'} />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </HeroContainer>
      <div className="!mt-[780px] lg:!mt-56">
        <ContactTestimonialCarousel />
      </div>
      <Footer />
    </div>
  );
}
